const chart = {
  primary: {
    color: 'indigo.60',
    '&:active, &:focus, &:visited': {
      color: 'indigo.90'
    },
    '&:hover': {
      color: 'indigo.90'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondary: {
    color: 'orange.45',
    '&:active, &:focus, &:visited': {
      color: 'orange.60'
    },
    '&:hover': {
      color: 'orange.60'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  primaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus, &:visited': {
      color: 'indigo.60'
    },
    '&:hover': {
      color: 'indigo.60'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus, &:visited': {
      color: 'orange.60'
    },
    '&:hover': {
      color: 'orange.45'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  navLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:hover': {
      '&::before': {
        content: '""',
        cursor: 'default',
        position: 'absolute',
        bottom: '-5px',
        left: '0',
        width: '100%',
        backgroundColor: 'coolGrey.100',
        height: '4px'
      }
    }
  },
  subNavLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus, &:visited': {
      color: 'indigo.60',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'indigo.60',
      textDecoration: 'underline'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  i18nSwitcher: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus, &:visited': {
      color: 'orange.60',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'indigo.60',
      textDecoration: 'underline'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  }
};

const co = {
  primary: {
    color: 'blue.60',
    '&:active, &:focus, &:visited': {
      color: 'blue.90'
    },
    '&:hover': {
      color: 'blue.90'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondary: {
    color: 'coolGrey.90',
    '&:active, &:focus, &:visited': {
      color: 'coolGrey.100'
    },
    '&:hover': {
      color: 'coolGrey.100'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  primaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus, &:visited': {
      color: 'blue.90'
    },
    '&:hover': {
      color: 'blue.60'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus, &:visited': {
      color: 'coolGrey.100'
    },
    '&:hover': {
      color: 'coolGrey.100'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  navLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:hover': {
      '&::before': {
        content: '""',
        cursor: 'default',
        position: 'absolute',
        bottom: '-5px',
        left: '0',
        width: '100%',
        backgroundColor: 'coolGrey.100',
        height: '4px'
      }
    }
  },
  subNavLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus, &:visited': {
      color: 'blue.90',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'blue.90',
      textDecoration: 'underline'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  i18nSwitcher: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus, &:visited': {
      color: 'blue.90',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'blue.90',
      textDecoration: 'underline'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  }
};

const edu = {
  primary: {
    color: 'indigo.70',
    '&:active, &:focus, &:visited': {
      color: 'indigo.80'
    },
    '&:hover': {
      color: 'indigo.80'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondary: {
    color: 'coolGrey.90',
    '&:active, &:focus, &:visited': {
      color: 'coolGrey.100'
    },
    '&:hover': {
      color: 'coolGrey.100'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  primaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus, &:visited': {
      color: 'indigo.80'
    },
    '&:hover': {
      color: 'indigo.70'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus, &:visited': {
      color: 'coolGrey.100'
    },
    '&:hover': {
      color: 'coolGrey.100'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  navLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:hover': {
      '&::before': {
        content: '""',
        cursor: 'default',
        position: 'absolute',
        bottom: '-5px',
        left: '0',
        width: '100%',
        backgroundColor: 'coolGrey.100',
        height: '4px'
      }
    }
  },
  subNavLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus, &:visited': {
      color: 'indigo.60',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'indigo.60',
      textDecoration: 'underline'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  i18nSwitcher: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus, &:visited': {
      color: 'indigo.80',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'indigo.80',
      textDecoration: 'underline'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  }
};

const press = {
  primary: {
    color: 'teal.30',
    '&:active, &:focus, &:visited': {
      color: 'teal.50'
    },
    '&:hover': {
      color: 'teal.50'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondary: {
    color: 'coolGrey.90',
    '&:active, &:focus, &:visited': {
      color: 'coolGrey.100'
    },
    '&:hover': {
      color: 'coolGrey.100'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  primaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus, &:visited': {
      color: 'teal.50'
    },
    '&:hover': {
      color: 'teal.30'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus, &:visited': {
      color: 'coolGrey.100'
    },
    '&:hover': {
      color: 'coolGrey.100'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  navLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:hover': {
      '&::before': {
        content: '""',
        cursor: 'default',
        position: 'absolute',
        bottom: '-5px',
        left: '0',
        width: '100%',
        backgroundColor: 'teal.30',
        height: '4px'
      }
    }
  },
  subNavLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus, &:visited': {
      color: 'teal.30',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'teal.30',
      textDecoration: 'underline'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  i18nSwitcher: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus, &:visited': {
      color: 'teal.50',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'teal.50',
      textDecoration: 'underline'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  }
};

const spark = {
  primary: {
    color: 'red.50',
    '&:active, &:focus, &:visited': {
      color: 'red.80'
    },
    '&:hover': {
      color: 'red.80'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondary: {
    color: 'indigo.90',
    '&:active, &:focus, &:visited': {
      color: 'indigo.100'
    },
    '&:hover': {
      color: 'indigo.100'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  primaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus, &:visited': {
      color: 'red.80'
    },
    '&:hover': {
      color: 'red.50'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus, &:visited': {
      color: 'indigo.90'
    },
    '&:hover': {
      color: 'indigo.90'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  navLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:hover': {
      '&::before': {
        content: '""',
        cursor: 'default',
        position: 'absolute',
        bottom: '-5px',
        left: '0',
        width: '100%',
        backgroundColor: 'coolGrey.100',
        height: '4px'
      }
    }
  },
  subNavLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus, &:visited': {
      color: 'red.50',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'red.50',
      textDecoration: 'underline'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  i18nSwitcher: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus, &:visited': {
      color: 'red.80',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'red.80',
      textDecoration: 'underline'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  }
};

const links = {
  ...chart,
  products: {
    chart,
    co,
    edu,
    press,
    spark
  }
};

export default links;
